<template>
	<div>
		<template v-for="message in items">
			<a v-if="message.fileId" class="text-dense" :href="fileDownloadUrl(message.fileId)" target="_blank">
				<span class="link">{{ message.fileName }}</span>
			</a>
		</template>
	</div>
</template>
<script>
import FileLink from "@/components/templates/agGrid/renderer/FileLink.vue";
import {fileuploadApi} from "@/common/api/fileuploadApi";

export default {
	components: { FileLink },
	computed: {
		items() {
			return this.params.value;
		}
	},
	methods: {
		fileDownloadUrl(fileId) {
			return fileuploadApi.getPdfUrl(fileId);
		}
	}
}
</script>